<template>
  <v-card max-width="250px" height="410px" class="mb-2 pt-3">
    <div class="card-content">
      <!-- <v-responsive aspect-ratio="1" class="image-container"> -->
      <!-- <v-img
        :src="car.images[0].public_link"
        width="250px"
        height="130px"
      > -->
      <v-img
        :src="car.public_image_link"
        width="250px"
        height="130px"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <!-- </v-responsive> -->
      <v-card-title style="word-break: normal; justify-content: center; height: 140px;" class="text-center">
        {{ car.name }}
      </v-card-title>
      <v-card-text style="height: 40px;">
        <v-layout align-start justify-center row>
          <div v-for="(features, index) in car.features" :key="index">
            <span v-if="features.id == 1" class="mx-1">
              <!-- Transmisión Automática -->
              <strong style="position: absolute; z-index: 1; font-size: 10px;" class="mt-4 ml-4">AT</strong>
              <v-icon color="red" >mdi-car-shift-pattern</v-icon>
              &nbsp;
            </span>
            <span v-if="features.id == 2" class="mx-1">
              <!-- Transmisión Maunal -->
              <strong style="position: absolute; z-index: 1; font-size: 10px;" class="mt-4 ml-4">MT</strong>
              <v-icon color="red" >mdi-car-shift-pattern</v-icon>
              &nbsp;
            </span>
            <span v-if="features.id == 3" class="mx-1">
              <!-- Aire Acondicionado -->
              <v-icon color="red" >mdi-air-conditioner</v-icon>
              &nbsp;
            </span>
            <span v-if="features.id == 4" class="mx-1">
              <!-- Radio -->
              <v-icon color="red" >mdi-radio</v-icon>
              &nbsp;
            </span>
            <span v-if="features.id == 5" class="mx-1">
              <!-- Dirección Asistida -->
              <v-icon color="red" >mdi-car-arrow-right</v-icon>
              &nbsp;
            </span>
            <span v-if="features.id == 6" class="mx-1">
              <!-- 4-puertas -->
              <strong style="position: absolute; z-index: 1; font-size: 10px;">4</strong>
              <v-icon color="red" >mdi-car-door</v-icon>
              &nbsp;
            </span>
            <span v-if="features.id == 7" class="mx-1">
              <!-- 5-puertas -->
              <strong style="position: absolute; z-index: 1; font-size: 10px;">5</strong>
              <v-icon color="red" >mdi-car-door</v-icon>
              &nbsp;
            </span>
          </div>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout align-center justify-center row>
          <v-btn color="red darken-1" dark href="/reserva" dense>
            {{ $t("reservar") }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    car: Object
  }
}
</script>